import {
  secondsToFormatHMin,
  secondsToFormatHMinS,
} from '~/common/utils/timeUtils';
import { TextProps, Text, Flex, Box } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

type DurationViewerProps = TextProps & {
  durationInSeconds: number;
  showSeconds?: boolean;
  label?: string;
  labelProps?: TextProps;
  labelParams?: string[];
  labelDescription?: string;
  labelDescriptionProps?: TextProps;
  labelDescriptionParams?: string[];
  col?: boolean;
  spaceBetween?: boolean;
};

export const DurationViewer: React.FC<DurationViewerProps> = ({
  durationInSeconds,
  showSeconds = false,
  label,
  labelProps,
  labelParams,
  labelDescription,
  labelDescriptionProps,
  labelDescriptionParams,
  col = false,
  spaceBetween = false,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <Flex
      mb={1}
      direction={!col ? 'row' : 'column'}
      justify={spaceBetween ? 'space-between' : undefined}
    >
      <Box>
        <Text fontSize="md" fontWeight="semibold" mr={1} {...labelProps}>
          {translate(label, labelParams)}
        </Text>
        <Text fontSize="sm" mr={1} mt={-2} {...labelDescriptionProps}>
          {translate(labelDescription, labelDescriptionParams)}
        </Text>
      </Box>
      <Text fontSize="md" whiteSpace="nowrap" {...props}>
        {showSeconds
          ? secondsToFormatHMinS(durationInSeconds, true, 2)
          : secondsToFormatHMin(durationInSeconds, true, 2)}
      </Text>
    </Flex>
  );
};
